class StickyAddToCart {
	constructor() {
		this.bar = document.querySelector( '.ts-sticky-cart' );

		if ( ! this.bar ) {
			return;
		}

		this.productForm = document.querySelector(
			'.single-product .summary form.cart'
		);
		this.variationForm =
			this.productForm &&
			this.productForm.classList.contains( 'variations_form' )
				? this.productForm
				: null;
		this.primaryButton =
			this.productForm &&
			this.productForm.querySelector( '.single_add_to_cart_button' );
		this.primaryQuantity =
			this.productForm && this.productForm.querySelector( 'input.qty' );
		this.stickyQuantity = this.bar.querySelector(
			'.ts-sticky-cart__quantity-input'
		);
		this.stickyButton = this.bar.querySelector( '.ts-sticky-cart__button' );
		this.price = this.bar.querySelector( '.ts-sticky-cart__price' );
		this.image = this.bar.querySelector( '.ts-sticky-cart__image' );
		this.defaultImage = this.image ? this.image.src : '';

		this.bindEvents();
		this.syncVariationSelects();
		this.syncQuantity();
		this.syncButton();
		this.observePrimaryButtonState();
		this.observePrimaryButton();
	}

	bindEvents() {
		this.bar
			.querySelectorAll( '.ts-sticky-cart__select' )
			.forEach( ( stickySelect ) => {
				stickySelect.addEventListener( 'change', () => {
					const primarySelect = this.getPrimarySelect(
						stickySelect.dataset.attribute
					);

					if ( ! primarySelect ) {
						return;
					}

					primarySelect.value = stickySelect.value;
					window.jQuery( primarySelect ).trigger( 'change' );
					this.syncButton();
				} );
			} );

		if ( this.variationForm ) {
			window
				.jQuery( this.variationForm )
				.on( 'found_variation.tsStickyCart', ( event, variation ) => {
					this.syncVariationSelects();
					this.syncQuantity();

					const variationImage =
						variation.image &&
						( variation.image.thumb_src || variation.image.src );
					if ( variationImage && this.image ) {
						this.image.src = variationImage;
					}
				} );

			window
				.jQuery( this.variationForm )
				.on(
					'show_variation.tsStickyCart hide_variation.tsStickyCart reset_data.tsStickyCart update_variation_values.tsStickyCart woocommerce_variation_select_change.tsStickyCart woocommerce_variation_has_changed.tsStickyCart',
					( event, variation, purchasable ) => {
						this.syncVariationSelects();
						this.syncButton();
					}
				);

			window.jQuery( this.variationForm ).on(
				'show_variation.tsStickyCartPrice',
				( event, variation, purchasable ) => {
					this.setPriceVisibility( !! purchasable );
				}
			);

			window.jQuery( this.variationForm ).on(
				'hide_variation.tsStickyCartPrice reset_data.tsStickyCartPrice',
				() => this.setPriceVisibility( false )
			);

			window
				.jQuery( this.variationForm )
				.on( 'reset_data.tsStickyCart', () => {
					if ( this.image ) {
						this.image.src = this.defaultImage;
					}
				} );
		}

		if ( this.primaryQuantity && this.stickyQuantity ) {
			window.jQuery( this.primaryQuantity ).on(
				'input.tsStickyCart change.tsStickyCart',
				() => {
					this.stickyQuantity.value = this.primaryQuantity.value;
					this.syncQuantity();
				}
			);

			this.stickyQuantity.addEventListener( 'input', () => {
				this.primaryQuantity.value = this.stickyQuantity.value;
				this.primaryQuantity.dispatchEvent(
					new Event( 'input', { bubbles: true } )
				);
				this.primaryQuantity.dispatchEvent(
					new Event( 'change', { bubbles: true } )
				);
			} );
		}

		this.bar
			.querySelectorAll( '[data-quantity-step]' )
			.forEach( ( button ) => {
				button.addEventListener( 'click', () => {
					const step = parseFloat( button.dataset.quantityStep );
					const minimum = parseFloat( this.stickyQuantity.min ) || 1;
					const maximum = this.stickyQuantity.max
						? parseFloat( this.stickyQuantity.max )
						: Infinity;
					const current =
						parseFloat( this.stickyQuantity.value ) || minimum;

					this.stickyQuantity.value = Math.min(
						maximum,
						Math.max( minimum, current + step )
					);
					this.stickyQuantity.dispatchEvent(
						new Event( 'input', { bubbles: true } )
					);
					this.stickyQuantity.dispatchEvent(
						new Event( 'change', { bubbles: true } )
					);
				} );
			} );

		if ( this.stickyButton ) {
			this.stickyButton.addEventListener( 'click', () => {
				if ( ! this.stickyButton.disabled && this.primaryButton ) {
					this.primaryButton.click();
				}
			} );
		}
	}

	setPriceVisibility( variationIsPurchasable ) {
		if ( this.price ) {
			this.price.hidden = variationIsPurchasable;
		}
	}

	getPrimarySelect( attributeName ) {
		if ( ! this.variationForm ) {
			return null;
		}

		const selectName = attributeName.startsWith( 'attribute_' )
			? attributeName
			: `attribute_${attributeName}`;

		return Array.from(
			this.variationForm.querySelectorAll( '.variations select' )
		).find( ( select ) => select.name === selectName );
	}

	syncVariationSelects() {
		this.bar
			.querySelectorAll( '.ts-sticky-cart__select' )
			.forEach( ( stickySelect ) => {
				const primarySelect = this.getPrimarySelect(
					stickySelect.dataset.attribute
				);

				if ( ! primarySelect ) {
					return;
				}

				stickySelect.value = primarySelect.value;
				Array.from( stickySelect.options ).forEach( ( option ) => {
					const primaryOption = Array.from(
						primarySelect.options
					).find( ( item ) => item.value === option.value );
					option.disabled =
						!! primaryOption && primaryOption.disabled;
				} );
			} );
	}

	syncQuantity() {
		if ( this.primaryQuantity && this.stickyQuantity ) {
			this.stickyQuantity.value = this.primaryQuantity.value;
			[ 'min', 'max', 'step' ].forEach( ( attribute ) => {
				const value = this.primaryQuantity.getAttribute( attribute );

				if ( value ) {
					this.stickyQuantity.setAttribute( attribute, value );
				} else {
					this.stickyQuantity.removeAttribute( attribute );
				}
			} );
		}
	}

	syncButton() {
		if ( ! this.stickyButton || ! this.primaryButton ) {
			return;
		}

		const variationId =
			this.variationForm &&
			this.variationForm.querySelector( 'input.variation_id' );
		const isDisabled =
			this.primaryButton.disabled ||
			this.primaryButton.classList.contains( 'disabled' ) ||
			!! ( variationId && ! parseInt( variationId.value, 10 ) );

		this.stickyButton.disabled = isDisabled;
		this.stickyButton.classList.toggle( 'disabled', isDisabled );
		this.stickyButton.setAttribute( 'aria-disabled', String( isDisabled ) );
	}

	observePrimaryButtonState() {
		if ( ! this.primaryButton || ! ( 'MutationObserver' in window ) ) {
			return;
		}

		const observer = new window.MutationObserver( () => {
			this.syncButton();
		} );

		observer.observe( this.primaryButton, {
			attributes: true,
			attributeFilter: [ 'class', 'disabled' ],
		} );
	}

	observePrimaryButton() {
		if ( ! this.primaryButton || ! ( 'IntersectionObserver' in window ) ) {
			this.showBar( true );
			return;
		}

		const observer = new window.IntersectionObserver(
			( entries ) => {
				this.showBar( ! entries[ 0 ].isIntersecting );
			},
			{ rootMargin: '-64px 0px -64px 0px' }
		);

		observer.observe( this.primaryButton );
	}

	showBar( visible ) {
		this.bar.classList.toggle( 'is-visible', visible );
		this.bar.setAttribute( 'aria-hidden', visible ? 'false' : 'true' );
		if ( visible ) {
			this.bar.removeAttribute( 'inert' );
		} else {
			this.bar.setAttribute( 'inert', '' );
		}
	}
}

export default StickyAddToCart;
